import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object used for validationScheme in signup procedure */
const PolicyManagementScheme = Yup.object().shape({
  title: Yup.string().required('Policy title is required'),
  version: Yup.string().required('Version is required'),
  owner: Yup.string().required('Policy owner is required'),
  // effectiveDate: Yup.string().required('Effective date is required'),
  // status: Yup.string().required('Policy current status is required'),
  // description: Yup.string().required('Description is required'),
  // policyMode: Yup.string().required('Policy content mode is required'),
  policyUrl: Yup.string().when('policyMode', {
    is: (value: string) => value === 'Content',
    then: (schema) => schema.optional(),
    otherwise: (schema) =>
      schema.required('Please enter url').url('Enter valid url'),
  }),
  // content: Yup.string().when('policyMode', {
  //   is: (value: string) => value === 'url',
  //   then: (schema) => schema.optional(),
  //   otherwise: (schema) => schema.required('Content is required'),
  // }),
});

const PolicyApprovalSchema = Yup.object().shape({
  approverId: Yup.string().required('Approver is required'),
  approverRole: Yup.string().required('Approver Role is required'),
});

export { PolicyManagementScheme, PolicyApprovalSchema };
